module.exports = __webpack_public_path__ + "static/img/zgs_log.0e0baae.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/index/assets/zgs_log.png
// module id = thLY
// module chunks = 1